import React from "react";
import {
  Show,
  SimpleShowLayout,
  TextField,
  NumberField,
  BooleanField,
  ChipField,
  ArrayField,
  Datagrid,
  FunctionField,
  TopToolbar,
  EditButton,
  DeleteButton,
} from "react-admin";
import { SubscriptionPlanLimiters } from "./SubscriptionPlanLimiters";

const SubscriptionPlanShowActions = () => (
  <TopToolbar>
    <EditButton />
    <DeleteButton />
  </TopToolbar>
);

export const SubscriptionPlanShow = () => {
  return (
    <Show actions={<SubscriptionPlanShowActions />} title="План подписки">
      <SimpleShowLayout>
        <TextField source="name" label="Название" />
        <ChipField source="type" label="Тип" />
        <TextField source="description" label="Описание" />
        <NumberField
          source="price"
          label="Цена"
          options={{ style: "currency", currency: "USD" }}
        />
        <TextField source="currency" label="Валюта" />
        <NumberField
          source="billingPeriodMonths"
          label="Период оплаты (месяцы)"
        />
        <BooleanField source="isActive" label="Активен" />
        <NumberField source="sortOrder" label="Порядок сортировки" />

        <ArrayField source="features" label="Особенности">
          <Datagrid>
            <TextField source="key" label="Ключ" />
            <TextField source="value" label="Значение" />
          </Datagrid>
        </ArrayField>

        <SubscriptionPlanLimiters />

        <FunctionField
          label="Всего подписок"
          render={(record: any) => record.userSubscriptions?.length || 0}
        />
      </SimpleShowLayout>
    </Show>
  );
};
